import { createListCollection, HStack, Icon, Text } from '@chakra-ui/react';
import { CustomSelect, Option } from '@components/ui/select/Select';
import { useSetTacticalClearanceMutation } from '@services/c2/track.api';
import { getTacticalClearanceStatusIcon } from '@utils/target.utils';
import { useIntl } from 'react-intl';

import { TacticalClearanceEnum, TargetStatusEnum } from '@/types/c2/c2.types';
import { TrackLight } from '@/types/sensor/sensors';
import { DataInfoSizeEnum } from '@/types/target.types';

type Props = {
  tacticalClearance: TacticalClearanceEnum;
  site: string;
  trackIds: TrackLight[];
  status: TargetStatusEnum;
  isDisabled?: boolean;
};

const formatLabel = (option: Option) => (
  <HStack gap={1.5} width="100%" overflow="hidden" textOverflow="ellipsis">
    <Icon
      width="24px"
      height="24px"
      as={getTacticalClearanceStatusIcon(option.value as TacticalClearanceEnum, DataInfoSizeEnum.TARGET_DETAIL)}
    />
    <Text textStyle="screenStd" color="neutral.white">
      {option.label}
    </Text>
  </HStack>
);

function TacticalClearanceSelect({ tacticalClearance, site, trackIds, status, isDisabled = false }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const [updateTacticalClearance] = useSetTacticalClearanceMutation();

  const tacticalClearanceOptions = Object.keys(TacticalClearanceEnum).map((tacticalClearance) => {
    return {
      value: tacticalClearance,
      label: formatMessage({ id: `target.tacticalClearance.${tacticalClearance}` }),
    };
  });

  return (
    <CustomSelect
      value={tacticalClearance}
      collection={createListCollection({ items: tacticalClearanceOptions })}
      disabled={isDisabled || status === TargetStatusEnum.LOST}
      width="100%"
      listWidth="100%"
      size="sm"
      formatLabel={formatLabel}
      onChange={(selectedOption) =>
        selectedOption &&
        updateTacticalClearance({
          tracks: trackIds,
          site,
          tacticalClearanceEnum: selectedOption as TacticalClearanceEnum,
        })
      }
    />
  );
}

export default TacticalClearanceSelect;
